import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchcategoriesById} from "../../../../../../reduxLib/pcategoriesLib";

function Pitemlist(props) {

    const dispatch = useDispatch();
    const [category, setCategory] = React.useState({});
    const categoryL=useSelector((state)=> state.categoryreducer.selectedCategory);
    const state=useSelector((state)=> state.categoryreducer.state);

    useEffect(() => {
        //if (!categoryL || categoryL.length === 0 ) {

            dispatch(fetchcategoriesById(props.category)).then((action) => {
                // Once the action is fulfilled, set the eventprofile state
                if (action.payload) {
                    setCategory(action.payload);


                    console.log("playload ",action.payload);
                    console.log("playload E", category);
                }
            });

        //}
        //else {
            // ίδια κατηγορία -> πάρε cached
            setCategory(categoryL);
        //}
    }, [dispatch, props.category]);


    return (
        <tr className="hover:bg-gray-50">
            <td className="px-6 py-4 whitespace-nowrap">
                <input type="checkbox" className="rounded"/>
            </td>
            <td className="px-6 py-4 whitespace-nowrap">
                <div className="flex items-center">
                    <img className="h-12 w-12 rounded-lg object-cover mr-4"
                         src={props.image}
                         alt={props.name}/>
                    <div>
                        <div className="text-sm font-medium text-gray-900">{props.name}</div>
                        <div className="text-sm text-gray-500">{props.description}
                        </div>
                    </div>
                </div>
            </td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{props.id}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{category?.name}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">€{props.price}</td>
            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                <div className="flex space-x-2">
                    <button onClick={props.onView} className="text-blue-600 hover:text-blue-900"><i
                        className="fa-solid fa-eye"></i></button>
                    <button onClick={props.onEdit} className="text-green-600 hover:text-green-900"><i
                        className="fa-solid fa-edit"></i></button>
                    <button onClick={props.onDelete} className="text-red-600 hover:text-red-900"><i
                        className="fa-solid fa-trash"></i></button>
                </div>
            </td>
        </tr>

    );

}

export default Pitemlist